import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import Router from 'vue-router'
import store from './store'
import plugins from './plugins' // plugins
import './assets/style/style.scss'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './components/toast/index.css'
// import common from './common/common.js'
import axios from './utils/axios'
import hasPermission from './utils/hasPermission'
import heightTable from './utils/heightTable'
import VueAxios from 'vue-axios'
import Toast from './components/toast/index'
import { resetForm } from "@/utils/short";
import debounceDirective from './utils/debounce'
Vue.directive('debounce', debounceDirective)

Vue.use(hasPermission, heightTable)
Vue.use(VueAxios, axios)
Vue.use(Element)
Vue.use(Toast)
Vue.use(plugins)

// 全局方法挂载
Vue.prototype.resetForm = resetForm
// Vue.prototype.common=common
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}